export const getCustomKeysForDCO = banners =>
  banners
    .map(({ elements }) => elements)
    .valueSeq()
    .flatten()
    .filter(({ customizable }) => customizable)
    .map(({ property }) => property)
    .toSet()
    .toArray();
